import { NgModule } from '@angular/core';
import { BudgetCategoryTreeComponent } from './budget-category-tree.component';
import { CategoriesService } from '../../../../../services/accounting/categories.service';
import { ChartOfAccountsService } from '../../../../../services/accounting/chart-of-accounts.service';
import { SharedModule } from '../../../../shared/shared.module';
import { CategoryEditorDialogModule } from '../category-editor-dialog/category-editor-dialog.module';
import { CategoryDeleteDialogModule } from '../category-delete-dialog/category-delete-dialog.module';
import { MatDialogModule } from '@angular/material/dialog';
import { DragulaModule, DragulaService } from 'ng2-dragula';

@NgModule({
    imports: [
        SharedModule,
        CategoryDeleteDialogModule,
        CategoryEditorDialogModule,
        MatDialogModule,
        DragulaModule,
    ],
    declarations: [BudgetCategoryTreeComponent],
    exports: [BudgetCategoryTreeComponent],
    providers: [
        CategoriesService,
        ChartOfAccountsService,
        DragulaService,
    ],
})
export class BudgetCategoryTreeModule
{
}
